import React from 'react';
import classNames from 'classnames';

// Radio group
const RadioButtonGroup = ({
  value,
  error,
  touched,
  id,
  label,
  className,
  children
}) => {
  const classes = classNames(
    "input-field",
    {
      "is-success": value || (!error && touched), // handle prefilled or user-filled
      "is-error": !!error && touched
    },
    className
  );

  return (
    <div  className={classes + " custom-form-check"}>
      {/* <fieldset>
        <legend>{label}</legend> */}
        {children}
      {/* </fieldset> */}
    </div>
  );
};

export default RadioButtonGroup;